import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'

import { Translation } from 'cng-common/features/translations'
import { Tag } from 'partner360/components/qualityIndicator'

import { TRANSLATION_KEYS } from '../../configs/translations'

import styles from './FinancialPlanRequirements.module.scss'

export const FinancialPlanRequirements = () => {
  return (
    <div className={styles.root}>
      <div className={styles.intro}>
        <Translation htmlAvailable text={TRANSLATION_KEYS.requirements.intro} />
      </div>

      <section className={styles.section}>
        <div className={styles.sectionTitle}>
          <Translation text={TRANSLATION_KEYS.requirements.whatWeScore} />
        </div>

        <div className={styles.scoreGrid}>
          <P360Card>
            <div className={styles.scoreCard__header}>
              <span className={styles.scoreCard__number}>1</span>
              <div className={styles.scoreCard__title}>
                <Translation text={TRANSLATION_KEYS.requirements.financialGrowth.title} />
              </div>
            </div>

            <div className={styles.scoreCard__description}>
              <Translation text={TRANSLATION_KEYS.requirements.financialGrowth.description} />
            </div>

            <div className={styles.tags}>
              <Tag variant={'Low'} translation={TRANSLATION_KEYS.requirements.low} />
              <Tag variant={'Moderate'} translation={TRANSLATION_KEYS.requirements.moderate} />
              <Tag variant={'High'} translation={TRANSLATION_KEYS.requirements.high} />
            </div>
          </P360Card>

          <P360Card>
            <div className={styles.scoreCard__header}>
              <span className={styles.scoreCard__number}>2</span>
              <div className={styles.scoreCard__title}>
                <Translation text={TRANSLATION_KEYS.requirements.sobGrowth.title} />
              </div>
            </div>

            <div className={styles.scoreCard__description}>
              <Translation text={TRANSLATION_KEYS.requirements.sobGrowth.description} />
            </div>

            <div className={styles.tags}>
              <Tag variant={'Low'} translation={TRANSLATION_KEYS.requirements.low} />
              <Tag variant={'Moderate'} translation={TRANSLATION_KEYS.requirements.moderate} />
              <Tag variant={'High'} translation={TRANSLATION_KEYS.requirements.high} />
            </div>
          </P360Card>
        </div>
      </section>
    </div>
  )
}
